import { Hex } from '@acies/core';
import { Flag, Service, Variant } from '@acies/domain';
import { theme } from '@acies/ui';
import AuthorizationError from '@shared/errors/authorization-error';
import InternalServerError from '@shared/errors/internal-server-error';
import NetworkError from '@shared/errors/network-error';
import ParseError from '@shared/errors/parse-error';
import UnknownError from '@shared/errors/unknown-error';
import UnSupportedMediaTypeError from '@shared/errors/unsupported-media-type-error';

type Errors = ParseError | NetworkError | AuthorizationError | InternalServerError | UnknownError | UnSupportedMediaTypeError | null;

export class AccountFlagsModel {
	public services: Service[];
	public networkErrorDialog: HTMLDialogElement | null;
	public unknownErrorDialog: HTMLDialogElement | null;
	public confirmationDialog: HTMLDialogElement | null;
	public confirmBody: string;
	public updatingFlagInstance: Flag | null;
	public updatingVariantInstance: Variant | null;
	public updatingFlags: boolean;
	#today: Date;
	#dateTimeFormatter: Intl.DateTimeFormat;
	public constructor() {
		this.services = [];
		this.updatingFlagInstance = null;
		this.updatingVariantInstance = null;
		this.updatingFlags = false;
		this.confirmBody = '';
		this.#today = new Date();
		this.#dateTimeFormatter = new Intl.DateTimeFormat('da-DK', { dateStyle: 'long' });
	}

	public showConfirmationDialog(): void {
		if (this.confirmationDialog) {
			this.confirmationDialog.showModal();
		}
	}

	public hideConfirmationDialog(): void {
		if (this.confirmationDialog) {
			this.confirmationDialog.close();
		}
	}

	public showNetworkErrorDialog(): void {
		if (this.networkErrorDialog) {
			this.networkErrorDialog.showModal();
		}
	}

	public hideNetworkErrorDialog(): void {
		if (this.networkErrorDialog) {
			this.networkErrorDialog.close();
		}
	}

	public showUnknownErrorDialog(): void {
		if (this.unknownErrorDialog) {
			this.unknownErrorDialog.showModal();
		}
	}

	public hideUnknownErrorDialog(): void {
		if (this.unknownErrorDialog) {
			this.unknownErrorDialog.close();
		}
	}

	public displayErrorDialogFromError(error: Errors = null): void {
		if (error instanceof NetworkError) {
			this.showNetworkErrorDialog();
		} else {
			this.showUnknownErrorDialog();
		}
	}

	public toDateString(value: Date): string {
		return this.#dateTimeFormatter.format(value);
	}

	public toDaysLeft(value: Date): number {
		const delta = value.getTime() - this.#today.getTime();
		if (delta <= 0) {
			return 0;
		}
		const ONE_DAY_IN_MILLI = 24 * 60 * 60 * 1000;
		return Math.ceil(delta / ONE_DAY_IN_MILLI);
	}

	public flagExpired(flag: Flag): boolean {
		return flag.expiresAt.getTime() < this.#today.getTime();
	}

	public cardColor(flag: Flag): Hex {
		return this.flagExpired(flag) ? theme.colors.fill.selected : theme.colors.fill.white;
	}
}
